var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCaution(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12119_49359)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9427 6.87477L11.4141 6.87477L13.6612 3.81744L16.0001 6.87477L14.4714 6.87477L14.4714 10.3398L12.9427 10.3398L12.9427 6.87477Z",
    fill: "#CCCFD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.52155 11.5527V12.9782H11.9736V11.5527C11.9736 11.5527 11.9736 8.7018 7.74759 8.7018C3.52155 8.7018 3.52155 11.5527 3.52155 11.5527ZM5.63457 5.13818C5.63457 4.71528 5.7585 4.30189 5.99068 3.95027C6.22286 3.59865 6.55287 3.32459 6.93897 3.16276C7.32508 3.00093 7.74994 2.95858 8.15982 3.04109C8.56971 3.12359 8.94621 3.32723 9.24172 3.62626C9.53723 3.92529 9.73848 4.30627 9.82001 4.72104C9.90154 5.1358 9.8597 5.56572 9.69977 5.95642C9.53984 6.34712 9.26901 6.68106 8.92152 6.916C8.57404 7.15095 8.16551 7.27635 7.74759 7.27635C7.18718 7.27635 6.64973 7.05108 6.25346 6.65009C5.85719 6.24911 5.63457 5.70526 5.63457 5.13818ZM3.38068 8.74457C2.99567 9.10399 2.68527 9.53743 2.46759 10.0196C2.24992 10.5017 2.12933 11.0229 2.11287 11.5527V12.9782H-0.000148773V11.5527C-0.000148773 11.5527 -0.000148773 9.0938 3.38068 8.74457ZM4.22589 3C4.4387 3.00013 4.65019 3.03379 4.85275 3.09978C4.44068 3.69774 4.21974 4.40919 4.21974 5.13818C4.21974 5.86716 4.44068 6.57861 4.85275 7.17657C4.65019 7.24256 4.4387 7.27622 4.22589 7.27635C3.66548 7.27635 3.12803 7.05108 2.73176 6.65009C2.33549 6.24911 2.11287 5.70526 2.11287 5.13818C2.11287 4.5711 2.33549 4.02724 2.73176 3.62626C3.12803 3.22527 3.66548 3 4.22589 3Z",
    fill: "#CCCFD1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12119_49359"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCaution);
export default __webpack_public_path__ + "static/media/icon-caution.a45a9eae413d4cedf9b5657d9d5d10fe.svg";
export { ForwardRef as ReactComponent };